var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('flip-countdown',{attrs:{"labels":_vm.labels,"deadline":"2024-11-29 08:00:00"},on:{"timeElapsed":_vm.timeElapsedHandler}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }